import React, { Component } from 'react';
import styled from 'styled-components';

import { WHITE, GREY, PRIMARY_LIGHT, PRIMARY } from '../constants/colors';
import { formatAtributeName } from '../services/formatAtributeName';

const InputWrapper = styled.div`
  width: 100%;
  text-transform: capitalize;
`;

const InputElement = styled.input`
  width: 100%;
  background-color: ${WHITE};
  border: 1px solid ${GREY};
  padding: 0 12px;
  outline: none;
  text-overflow: clip;
  font-size: 14px;
  border-radius: 3px;
  height: 28px;

  &:hover {
    background-color: ${PRIMARY_LIGHT};
    border: 1px solid ${PRIMARY};
  }

  &:focus {
    border: 1px solid ${PRIMARY};
  }
`;

export class Input extends Component {
  render() {
    const newString = this.props.placeholder.replace(/_/g, ' ');

    return (
      <InputWrapper>
        <label htmlFor={`input-${this.props.placeholder}`}>
          {formatAtributeName(newString)}
        </label>
        <InputElement {...this.props} placeholder="" />
      </InputWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Input.js